import React, { ReactElement } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField, { TextFieldProps } from "@material-ui/core/TextField/TextField";
import { match, parse } from "../../lib/AutosuggestHighlight";

export interface CustomAutocompleteProps {
  disabled?: boolean;
  error?: boolean;
  freeSolo?: boolean;
  getOptionLabel?: (option: any) => string;
  getOptionSelected?: (option: any, value: any) => boolean;
  helperText?: string;
  label: string;
  mandatory?: boolean;
  onClose?: (event: object, reason?: string) => void;
  onChange: (event: object, value: any, reason?: string) => void;
  onInputChange?: (event: object, value: any, reason?: string) => void;
  optionKey?: string;
  options: any[];
  value: any;
}

const CustomAutocomplete = (props: MergedProps<CustomAutocompleteProps, TextFieldProps>): ReactElement => {
  const {
    disabled,
    error,
    freeSolo,
    getOptionLabel,
    getOptionSelected,
    helperText,
    label,
    mandatory,
    onClose,
    onChange,
    onInputChange,
    optionKey,
    options,
    value,
    ...TextFieldProps
  } = props;

  return (
    <Autocomplete
      freeSolo={freeSolo}
      autoHighlight
      value={value}
      onInputChange={(e, val) => {
        if (onInputChange) {
          onInputChange(e, val);
        }
      }}
      onChange={onChange}
      onClose={onClose}
      noOptionsText="Please enter or adjust a search term"
      options={options}
      disabled={disabled}
      ListboxProps={{
        style: {
          maxHeight: "10rem",
        },
      }}
      getOptionLabel={optionKey ? (option: any) => option[optionKey.toString()] || "" : getOptionLabel}
      getOptionSelected={optionKey ? (option: any) => !!option[optionKey.toString()] : getOptionSelected}
      renderInput={(params): ReactElement => (
        <TextField
          {...params}
          error={error}
          fullWidth
          helperText={helperText}
          label={mandatory ? `${label}*` : label}
          variant="outlined"
          {...TextFieldProps}
        />
      )}
      renderOption={(option, { inputValue }): ReactElement => {
        const matches = match(optionKey ? option[optionKey.toString()] : option, inputValue);
        const parts = parse(optionKey ? option[optionKey.toString()] : option, matches);

        return (
          <div>
            {parts.map((part: any, index: number) => (
              <span key={part + index.toString()} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                {part.text}
              </span>
            ))}
          </div>
        );
      }}
    />
  );
};

export default CustomAutocomplete;
